"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var FlowOutline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.PureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_FlowOutline_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0a2 2 0 0 1 1.937 1.5H6A2.5 2.5 0 0 1 8.5 4v2.063c.703.18 1.256.734 1.437 1.437h4.356l-1.647-1.646a.5.5 0 0 1 .708-.708l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 8.5H9.937A2.004 2.004 0 0 1 8.5 9.937V12A2.5 2.5 0 0 1 6 14.5H3.937a2 2 0 1 1 0-1H6A1.5 1.5 0 0 0 7.5 12V9.937A2.004 2.004 0 0 1 6.063 8.5H3.937a2 2 0 1 1 0-1h2.126A2.004 2.004 0 0 1 7.5 6.063V4A1.5 1.5 0 0 0 6 2.5H3.937A2 2 0 1 1 2 0Zm0 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 10a1 1 0 1 1 0 2 1 1 0 0 1 0-2Zm1-5a1 1 0 1 0-2 0 1 1 0 0 0 2 0Zm4.5-.866A1.005 1.005 0 0 0 7 8a.995.995 0 0 0 .5.866.995.995 0 0 0 1 0A1.005 1.005 0 0 0 9 8a.995.995 0 0 0-.5-.866.995.995 0 0 0-1 0Z"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_FlowOutline_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = FlowOutline;
exports["default"] = _default;